module.exports = __webpack_public_path__ + "img/zunge-zk.8637d267.svg";